import React, { useState, useRef } from 'react';

import Layout from '../components/Layout';
import UserManagement from './UserManagement';
import Usage from './Usage';
import InterviewAnalysis from './InterviewAnalysis';
import QuestionBankAnalysis from './QuestionBankAnalysis';
import ApiTest from './ApiTest';
import BugReports from './BugReports';

const DashboardPage: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<'userManagement' | 'usage' | 'interviewAnalysis' | 'questionBankAnalysis' | 'apiTest' | 'bugReports'>('userManagement');
  const refreshPendingBugsRef = useRef<(() => void) | null>(null);

  const handlePageChange = (page: string) => {
    if (
      page === 'userManagement' ||
      page === 'usage' ||
      page === 'interviewAnalysis' ||
      page === 'questionBankAnalysis' ||
      page === 'apiTest' ||
      page === 'bugReports'
    ) {
      setCurrentPage(page);
    }
  };

  const renderCurrentPage = () => {
    switch (currentPage) {
      case 'userManagement':
        return <UserManagement />;
      case 'usage':
        return <Usage />;
      case 'interviewAnalysis':
        return <InterviewAnalysis />;
      case 'questionBankAnalysis':
        return <QuestionBankAnalysis />;
      case 'apiTest':
        return <ApiTest />;
      case 'bugReports':
        return <BugReports onBugStatusChange={() => refreshPendingBugsRef.current?.()} />;
      default:
        return <UserManagement />;
    }
  };

  return (
    <Layout 
      currentPage={currentPage} 
      onPageChange={handlePageChange}
      refreshPendingBugs={refreshPendingBugsRef}
    >
      {renderCurrentPage()}
    </Layout>
  );
};

export default DashboardPage;
